var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwimmer4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 42,
    viewBox: "0 0 77 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zct08oah1a",
    d: "M0 0h32.834v23.57H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "oxqapqkpjc",
    d: "M0 0h33.863v21.777H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.04 0c.99 0 1.16 1.22 2.38 1.19 1.23-.03 2.28-.14 2.82.41.598.586.67 3.453-1.02 1.56l-4.07.92c-5.383 4.924-7.14 6.612-8.409 8.254l-.17.224-.167.226-.163.228c-.734 1.037-1.445 2.22-2.861 4.288 1.773-.98 1.56-.852 1.623-.536l.011.047c.132.453.986 1.172 8.336-.191-.512.378-1.72 1.141-2.934 1.891l-.454.28c-1.431.88-2.75 1.669-2.802 1.699-.1.058-5.552 10.777-13.27 9.62-.478.954-4.672.886-4.99.98-1.7.478-.444 1.145-4.97 4.3 6.128 0 5.587-.531 10.01 1.54 1.808-.697 1.144.708-1.06.5 1.892.219 3.555-.277 2.91.4 1.621 0-1.419 1.364-3.03 1.13 0 0 1.05.71 1.16.71 2.696 0-.001 2.011-3.73-1.02 0 0-.12.42-.09.46 1.102 1.099.173 3.545-.23 1.53-.02-.15-1.1-.91-1.38-1.2-3.015-3.124 2.417-2.525-5.67-1.31-6.057.892-6.546.744-7.33 1.015l-.105.038c-.357.134-.818.36-1.865.797C2.253 41.348.527 38.961 0 39.06c1.146-.529.87-.186 1.11-1.59 2.44-.204 8.449-.918 10.58-2.08 3.506-1.896 8.358-9.015 10.41-9.05 3.748-.065 21.88-6.856 3.42-7.26-8.62 0-4.373-1.63.243-3.01l.44-.13c2.572-.757 5.135-1.418 5.547-1.66 1.09-.65 2.48-5.07 4.72-6.5.92-.58 2.474-1.568 4.025-2.555l.517-.329A596.117 596.117 0 0 1 45.3 2.18",
    id: "jbj4jn08ce"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-32.231%",
    y1: "243.583%",
    x2: "115.12%",
    y2: "-102.135%",
    id: "qthj5ds0nf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#173889",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3CDEB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.834)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5oqn0vww5b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zct08oah1a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m31.428 3.16-4.07.92c-11.791 10.784-9.14 10.243-13.69 15.85-1.724 2.155-8.415 3.64-10.96 3.64-3.301 0-3.162-4.197-1.81-5.52 0-.975 9.523-2.867 11.06-3.77 1.09-.65 2.48-5.07 4.72-6.5 2.25-1.42 8.28-5.27 8.83-5.6.56-.32.76-2.18 1.74-2.18.99 0 1.16 1.22 2.38 1.19 1.23-.03 2.28-.14 2.82.41.597.586.67 3.453-1.02 1.56",
    fill: "#F19E8C",
    mask: "url(#5oqn0vww5b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.142 27.45c-1.342 4.034-18.048 7.975-16.96-.6 0-.395-.484 1.194 5.03-5.3 3.837-4.77 9.331-4.308 10.68-1.61.904 1.724 2.038 5.934 1.25 7.51",
    fill: "#F5A997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.062 27.6c-1.16 1.839-.907 2.53-1.15 2.53-2.4 1.36-3.85.63-4.97.96 1.857-4.51-2.348-9.806-5.73-9.54-.1 0 .968-1.935 3.8-3.08 7.873-3.027 10.043 5.97 8.05 9.13",
    fill: "#3270DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.802 38.96s1.05.71 1.16.71c2.695 0 0 2.01-3.73-1.02 0 0-.12.42-.09.46 1.101 1.1.173 3.545-.23 1.53-.02-.15-1.1-.91-1.38-1.2-3.016-3.124 2.416-2.524-5.67-1.31-8.955 1.319-5.74.366-9.3 1.85-2.22.93-4.09-.09-4.09-.09 1.19-5.11 5.994-4.545 14.5-4.5 6.128 0 5.586-.531 10.01 1.54 1.807-.697 1.144.708-1.06.5 1.891.219 3.554-.276 2.91.4 1.621 0-1.419 1.364-3.03 1.13",
    fill: "#F19E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.282 30.53c.066 1.714-4.467 6.72-13.15 7.98-1.07.155-5.468 2.909-6.67.56-.39 0-1.688-8.994 3.13-11.34 5.004-2.438 16.591.422 16.69 2.8",
    fill: "#F8B4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.04 34.091c-2.101-3.248-.453-.05 1.869-1.19 1.37-.67 1.173-1.174 1.853-.85.679.324 1.665 2.992 1.257 4.25-.376 1.158-3.746 1.731-4.98-2.21",
    fill: "#F19E8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.782 38.625c-3.744.42-3.406-6.547-.358-7.112 2.957-.548 5.072 1.772 5.238 2.039.166.268-.678 4.104-1.257 4.219-.578.115-3.623.854-3.623.854",
    fill: "#0A3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.042 39.06c-.158.02-2.987 1.226-3.77.6-1.906.318-3.045.499-4.612-.91.824-2.067 1.382-4.767 3.642-4.39 3.051.58-1.202-2.071.28-2.4.1-.05 1.886-.056 2.11 1.29 3.636 1.369 4.404 5.425 2.35 5.81",
    fill: "#F8B4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.129 31.354c1.349.14 2.911 2.084 3.429 2.83 1.675 2.408-.534 3.786-.474 3.901 1.285 2.491-1.176 2.931-1.89 1.803-.431-.68.895-1.514.637-2.598-.371-1.559.704-5.008-1.702-5.936",
    fill: "#CAD4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.36 36c-.484 1.651.914 1.8 1.2 1.045.628-1.666-.81-2.453-1.2-1.045M14.867 38.98c-.72 1.56.64 1.914 1.033 1.21.867-1.556-.44-2.547-1.033-1.21",
    fill: "#0A3192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 27.854c-10.552-.627-11.402-3.552-18.609 6.883-3.203-1.248-8.89-2.882-3.806-.47-2.596-.097-3.075-.14-3.064.005.082 1.026 1.598.181.134.81-.336.143-.12.605.586.553.351-.025 2.346.204 2.346.204-4.106.574-2.228.858-2.052.842 5.938-.566 1.06.827 1.047 1.013-.04.574 3.704.986 6.016-1.326 11.664-9.21 5.17-5.488 12.253-4.588 1.48.187 1.206 2.056 3.467.782 2.26-1.275 1.682-4.708 1.682-4.708",
    fill: "#F8B4A1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.336 8.42)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fk15lwg3dd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oxqapqkpjc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.276 7.5c-.43.03-.99-.05-1.18-.4-.76-1.441-3.563-3.003-4.07-2.91-1.001.16-1.824 2.433-11.16 7.88-.1.058-5.552 10.777-13.27 9.62-4.058-.193-3.774-6.54-3.39-6.54 1.927-4.816 5.173-3.52 8.45-4.36 1.125 0 4.824-2.166 5.49-2.46 1.783-.773 2.099-2.461 5.17-3.68 2.885-1.152 6.482-2.19 7.56-2.96 1.25-.84.85-1.91 2.41-1.65.9.14 1.55 2.57 2.49 2.72 2.766.47 2.23 4.707 1.5 4.74",
    fill: "#F5A997",
    mask: "url(#fk15lwg3dd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.042)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "rt1y23uccg",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jbj4jn08ce"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m51.22 3.16-4.07.92c-9.421 8.617-7.733 7.323-11.77 13.22 4.282-2.366-3.023 1.729 9.97-.68-1.185.873-6.088 3.811-6.19 3.87-.1.058-5.552 10.777-13.27 9.62-.478.954-4.672.886-4.99.98-1.7.478-.444 1.145-4.97 4.3 6.128 0 5.587-.531 10.01 1.54 1.808-.697 1.144.708-1.06.5 1.892.219 3.555-.277 2.91.4 1.621 0-1.419 1.364-3.03 1.13 0 0 1.05.71 1.16.71 2.696 0-.001 2.011-3.73-1.02 0 0-.12.42-.09.46 1.102 1.099.173 3.545-.23 1.53-.02-.15-1.1-.91-1.38-1.2-3.015-3.124 2.417-2.525-5.67-1.31-8.954 1.318-5.74.365-9.3 1.85C2.253 41.348.527 38.961 0 39.06c1.146-.529.87-.186 1.11-1.59 2.44-.204 8.449-.918 10.58-2.08 3.506-1.896 8.358-9.015 10.41-9.05 3.748-.065 21.88-6.856 3.42-7.26-13.682 0 5.052-4.108 6.23-4.8 1.09-.65 2.48-5.07 4.72-6.5 2.25-1.42 8.28-5.27 8.83-5.6.56-.32.76-2.18 1.74-2.18.99 0 1.16 1.22 2.38 1.19 1.23-.03 2.28-.14 2.82.41.598.586.67 3.453-1.02 1.56",
    fill: "url(#qthj5ds0nf)",
    mask: "url(#rt1y23uccg)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmer4);
export default __webpack_public_path__ + "static/media/swimmer4.c8e3e7780cddd90bddf5db2dd27c2a77.svg";
export { ForwardRef as ReactComponent };